import React from 'react';
import { ExpressionInputConnected } from '../expressions';
export function ChecklistExpressionDisplay(props) {
    return (React.createElement(ExpressionInputConnected, Object.assign({ includeBlockSuggestions: true, includeFactSuggestions: true, readOnly: true }, props)));
}
